import CloseIcon from '@/common/assets/icons/closeIcon.svg?react';
import TickIcon from '@/common/assets/icons/tickIcon.svg?react';
import InfoIcon from '@/common/assets/icons/infoCircleIcon.svg?react';
import DangerIcon from '@/common/assets/icons/dangerIcon.svg?react';
import useRenderWithDelay from '@/common/hooks/useRenderWithDelay.ts';
import { ToastPropsType } from '@/common/components/base/toast/Toast.type.ts';
import useIsFirstRender from '@/common/hooks/useIsFirstRender.ts';
import toast, {
  ToastTypes,
} from '@/common/components/base/toast/toast.recipe.ts';
import { createPortal } from 'react-dom';
import { Box, Circle, Flex } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';

const Toast = (props: ToastPropsType) => {
  const { isRender } = useRenderWithDelay(props.show, 500);
  return isRender ? <ToastBody {...props} /> : null;
};
export const ToastBody = ({
  show,
  type,
  closeAlert,
  description,
}: ToastPropsType) => {
  const isFirstRender = useIsFirstRender();
  const Icon = icons[type];
  const toastStyles = toast({ type, show: !isFirstRender && show });
  return createPortal(
    <Box zIndex="toast" position="fixed" top="0" right="0" left="0">
      <Flex className={toastStyles.body}>
        <Flex gap="6px" alignItems="center">
          <Circle className={toastStyles.alertIconBackground}>
            <Icon width="100%" height="100%" stroke="white" />
          </Circle>
          <Typography textStyle="b2">{description}</Typography>
        </Flex>
        <CloseIcon onClick={closeAlert} className={toastStyles.closeIcon} />
      </Flex>
    </Box>,
    document.body,
  );
};
export default Toast;

const icons: Record<ToastTypes, any> = {
  success: TickIcon,
  error: CloseIcon,
  info: InfoIcon,
  warning: DangerIcon,
};
